/**
 * @author vishwadeep.kapoor
 * Selectors for LoginPage
 *
 */

import { createSelector } from 'reselect';
import { utils } from '../../devUtils';

const selectLoginPageDomain = (state) => state.get('loginPage');

// const selectLoginPage = () => createSelector(
//   selectLoginPageDomain,
//   (loginPage) => loginPage.toJS(),
// );

const selectLoginForm = () => createSelector(
  selectLoginPageDomain,
  (loginPage) => loginPage.get('form').toJS(),
);

/**
 * @deprecated
 */
// const selectSignUpForm = () => createSelector(
//   selectLoginPageDomain,
//   (loginPage) => utils.immutableToJS(loginPage.get('signUpform')),
// );

/** @todo @requires /client/containers/ManageZaggleCard/index.js validation */
const selectIsOtpRequested = () => createSelector(
  selectLoginPageDomain,
  (loginPage) => utils.immutableToJS(loginPage.get('otpRequestSuccess')),
);

const selectForgotForm = () => createSelector(
  selectLoginPageDomain,
  (loginPage) => utils.immutableToJS(loginPage.get('forgotForm')),
);

const selectOtpSent = () => createSelector(
  selectLoginPageDomain,
  (loginPage) => loginPage.get('otpSent'),
);

const selectOtpSubmit = () => createSelector(
  selectLoginPageDomain,
  (loginPage) => loginPage.get('otpSubmit'),
);

const selectSetPassowrdForm = () => createSelector(
  selectLoginPageDomain,
  (loginPage) => utils.immutableToJS(loginPage.get('setPasswordForm')),
);

const selectSetPasswordSubmit = () => createSelector(
  selectLoginPageDomain,
  (loginPage) => loginPage.get('setPasswordSubmit'),
);

const selectShowLoginForm = () => createSelector(
  selectLoginPageDomain,
  (loginPage) => loginPage.get('isShowLogin'),
);
const selectIsLoginSuccess = () => createSelector(
  selectLoginPageDomain,
  (loginPage) => loginPage.get('isLoginSuccess'),
);
const select_LoginJS = (key) => createSelector(
  selectLoginPageDomain,
  (loginPage) => utils.immutableToJS(loginPage.get(key)),
);
export {
  selectLoginPageDomain,
  select_LoginJS,
  // selectLoginPage,
  selectLoginForm,
  // selectSignUpForm,
  selectIsOtpRequested,
  selectForgotForm,
  selectOtpSent,
  selectOtpSubmit,
  selectSetPassowrdForm,
  selectSetPasswordSubmit,
  selectShowLoginForm,
  selectIsLoginSuccess,
};



// WEBPACK FOOTER //
// client/containers/LoginPage/selectors.js